<template>
  <div
    v-if="productSettings.productPageUsps && productSettings.productPageUsps.length"
    class="bg-grey200 py-10 sm:flex md:block lg:flex justify-center rounded-md sm:py-12 flex-wrap"
  >
    <div
      v-for="(usp, index) in productSettings.productPageUsps"
      :key="index"
      class="px-12 sm:text-center md:text-left lg:text-center w-auto mb-6 sm:mb-0 md:mb-6 lg:mb-0 last:mb-0"
    >
      <img
        v-if="usp.iconUrl"
        :src="usp.iconUrl"
        class="w-16 inline-block mr-12 sm:w-20"
        alt="Usp icon"
        height="20"
        width="20"
      >
      <WysiwygWrapper
        v-if="usp.text"
        :style-config="{
          'wysiwyg wysiwyg--sm-text inline-block': true,
        }"
        :html="usp.text"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
const productSettings = useGlobalContentStore().productSettings;
</script>
